import { api } from "@/lib/api";
import type { ChangePasswordRequest } from "@/types/api";

export const accountApi = {
  changePassword: (body: ChangePasswordRequest) =>
    api.post<{ success: boolean }>("/api/account/change-password", body),
};
